var _path, _path2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlCmdGripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0044 24.2979L28.694 14.5345L18.712 8.85813",
    stroke: "#4ED064",
    strokeMiterlimit: 3.99393
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98778 24.2979L4.29816 14.5345L14.2802 8.85813",
    stroke: "#4ED064",
    strokeMiterlimit: 3.99393
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9.0498,
    x2: 23,
    y2: 9.0498,
    stroke: "#DFD8D0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 1.50635e-8,
    x2: 14.5,
    y2: 9,
    stroke: "#DFD8D0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 1.50635e-8,
    x2: 18.5,
    y2: 9,
    stroke: "#DFD8D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCmdGripIcon);
export default __webpack_public_path__ + "static/media/control-cmd-grip-icon.29086b2b3667f3553de293dc7de83f30.svg";
export { ForwardRef as ReactComponent };